import React, { useState } from 'react';
import './EditCensorModal.css'; // Genbrug styles

const CreateUserModal = ({ onClose, onCreate, user, centers = [] }) => {
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    role: 'TEACHER',
    sprogcenter_id: user?.role === 'SC_ADMIN' ? user.scId : '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreate(formData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Opret Bruger Login</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
            <div className="modal-form-grid">
              {user?.role === 'ADMIN' && (
                <div className="form-group full-width">
                  <label>Sprogcenter</label>
                  <select value={formData.sprogcenter_id} onChange={e => setFormData({ ...formData, sprogcenter_id: e.target.value })} required>
                    <option value="">-- Vælg sprogcenter --</option>
                    {centers.map((center) => <option key={center.id} value={center.id}>{center.navn}</option>)}
                  </select>
                </div>
              )}
              <div className="form-group">
                <label>Fornavn</label>
                <input value={formData.firstName} onChange={e => setFormData({ ...formData, firstName: e.target.value })} required />
              </div>
              <div className="form-group">
                <label>Efternavn</label>
                <input value={formData.lastName} onChange={e => setFormData({ ...formData, lastName: e.target.value })} required />
              </div>
              <div className="form-group full-width">
                <label>Email (Brugernavn)</label>
                <input type="email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} required />
              </div>

              <div className="form-group full-width">
                <label>Rolle i systemet</label>
                <select value={formData.role} onChange={e => setFormData({ ...formData, role: e.target.value })} style={{ width: '100%', padding: '10px' }}>
                  <option value="TEACHER">Underviser / Censor (Adgang til egne hold)</option>
                  <option value="SC_ADMIN">Administrator (Fuld adgang til sprogcenter)</option>
                </select>
              </div>

            </div>

            <div className="modal-actions" style={{ marginTop: '20px' }}>
              <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
              <button type="submit" className="btn-save">Opret Bruger</button>
            </div>
        </form>
      </div>
    </div>
  );
};

export default CreateUserModal;
